import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { HZRecorder } from '@/js/page/HZRecorder.js';
import wx from 'weixin-js-sdk';
export default {
  name: 'Record',
  props: {
    "initAudioSrc": Array,
    setInfo: {
      type: Object,
      default: {
        //是否显示录制结果
        ifShowReslut: 1,
        //准备时长
        preparatTime: 0,
        //录制时长
        recordTime: 0
      }
    },
    //录制类型 0：默认类型  1:托福真题录制(准备时长,录制时长)  2:检测麦克风
    showType: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      startBtnName: "开始录制",
      endBtnName: "结束录制",
      preparatName: "准备中",
      recordingName: "录制中",
      isRecording: false,
      recorder: null,
      blob: null,
      startState: false,
      endState: true,
      audioSrc: [],
      //是否可重复录制
      ifCanRepeat: false,
      ifCanStart: true,
      //录制时长
      recordTime: 0,
      //录制时长的记录对象
      recordInterval: null,
      //剩余录制时长
      canUseTime: 0,
      //录制类型 0:准备时间 1:正式录制
      recordType: 1,
      //音频总时长
      duration: 0,
      //当前的播放百分比
      playProgress: 0,
      //提示语
      promptingLanguage: 'Recording...'
    };
  },
  watch: {
    audioSrc: function audioSrc(value) {
      console.log("value=============================", value);
      this.$emit('callBack', value);
    },
    //播放时 进行播放的百分比计算
    recordTime: function recordTime(val) {
      var maxTime = 0;

      if (this.recordType == 0) {
        maxTime = this.setInfo.preparatTime;
      } else if (this.recordType == 1) {
        maxTime = this.setInfo.recordTime;
      }

      if (maxTime > 0) {
        this.canUseTime = maxTime - val;
        console.log("====================", maxTime, val, this.canUseTime);

        if (this.canUseTime <= 0) {
          this.canUseTime = 0; //结束录制

          this.endRecord();
        }
      }

      this.playProgress = (val / maxTime * 100).toFixed(0) * 1;
    }
  },
  computed: {
    second: function second() {
      return this.num(this.canUseTime % 60);
    },
    minute: function minute() {
      return this.num(parseInt(this.canUseTime / 60));
    }
  },
  created: function created() {
    if (this.initAudioSrc) {
      this.audioSrc = this.initAudioSrc;
      this.audioSrc.forEach(function (element) {
        element.src = 'edus_auto/DownLoadFile?str=' + element.downAddress;
        element.controls = true;
      });
      console.log("this.audioSrc============", this.audioSrc);
    }

    if (this.showType == 1 || this.showType == 2) {
      this.startBtnName = "Record";
      this.endBtnName = "end";
      this.preparatName = "preparing";
      this.recordingName = "recording";
      this.ifCanRepeat = false;
    }
  },
  mounted: function mounted() {
    this.initUtil();
    this.initRecorder();
  },
  methods: {
    num: function num(n) {
      return n < 10 ? '0' + n : '' + n;
    },
    initUtil: function initUtil() {
      var Util = {
        //初始化
        init: function init() {
          navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
          window.AudioContext = window.AudioContext || window.webkitAudioContext;
        },
        //日志
        log: function log() {
          console.log.apply(console, arguments);
        }
      };
      Util.init();
    },
    initRecorder: function initRecorder() {
      var that = this;
      var recorder = null;
      this.$nextTick(function () {
        function successFun(stream) {
          var config = config || {};
          config.sampleBits = config.sampleBits || 8; //采样数位 8, 16

          config.sampleRate = config.sampleRate || 44100 / 6; //采样率(1/6 44100)

          recorder = new HZRecorder(stream, config);
          console.log('初始化完成');
          that.recorder = recorder;
          console.log("===================================", recorder);
        }

        function errorFun(error) {
          var msg;

          switch (error.code || error.name) {
            case 'PermissionDeniedError':
            case 'PERMISSION_DENIED':
            case 'NotAllowedError':
              msg = '用户拒绝访问麦克风';
              break;

            case 'NOT_SUPPORTED_ERROR':
            case 'NotSupportedError':
              msg = '浏览器不支持麦克风';
              break;

            case 'MANDATORY_UNSATISFIED_ERROR':
            case 'MandatoryUnsatisfiedError':
              msg = '找不到麦克风设备';
              break;

            default:
              msg = '无法打开麦克风，异常信息:' + (error.code || error.name);
              break;
          }

          alert(msg);
        }

        that.getUserMedia({
          audio: true
        }, successFun, errorFun);
      });
    },
    getUserMedia: function getUserMedia(constrains, success, error) {
      console.log("navigator.mediaDevices=================", navigator.mediaDevices);
      console.log("navigator.webkitGetUserMedia=================", navigator.webkitGetUserMedia);
      console.log("navigator.mozGetUserMedia=================", navigator.mozGetUserMedia);
      console.log("navigator.getUserMedia=================", navigator.getUserMedia);

      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        //最新标准API
        navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error);
      } else if (navigator.webkitGetUserMedia) {
        //webkit内核浏览器
        navigator.webkitGetUserMedia(constrains).then(success).catch(error);
      } else if (navigator.mozGetUserMedia) {
        //Firefox浏览器
        navagator.mozGetUserMedia(constrains).then(success).catch(error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constrains).then(success).catch(error);
      }
    },
    clickPreparatRecord: function clickPreparatRecord() {
      var that = this; // 如果是不可重复录制的 判断是否已经有录制音频 如果已经有了 不可重复录制

      if (!this.ifCanRepeat) {
        if (this.initAudioSrc && this.initAudioSrc.length > 0) {
          this.$message({
            message: '不可重复录制,已经录制结束',
            type: 'warning'
          });
          return;
        }
      } //判断是否需要播放准备录音  播放后开始进行准备倒计时


      if (this.setInfo.preparatTime > 0) {
        var audio = new Audio();
        audio.src = that.GLOBAL.baseURL + "record_mp3/preparta_record.mp3";
        audio.addEventListener('ended', function () {
          console.log("开始准备录制--");
          that.recordType = 0;
          that.startRecord();
        });
        audio.play();
      } else {
        try {
          that.clickZsRecord();
        } catch (err) {
          console.log("err=====================", err);
          alert("浏览器没有获取到录音权限!");
        }
      }
    },
    clickZsRecord: function clickZsRecord() {
      var that = this;

      if (this.setInfo.recordTime > 0 && this.showType == 1) {
        var audio = new Audio();
        audio.src = that.GLOBAL.baseURL + "record_mp3/zs_record.mp3";
        audio.addEventListener('ended', function () {
          console.log("开始正式录制--");
          that.recordType = 1;
          that.startRecord();
        });
        audio.play();
      } else {
        that.recordType = 1;
        that.startRecord();
      }
    },
    startRecord: function startRecord() {
      var that = this; //准备录制结束后 播放正式录制的提示语音 播放结束后 开始进行正式录制

      console.log(that.recordType);
      var isRecording = this.isRecording;
      this.recordTime = 0;

      if (that.recordType == 1) {
        var recorder = this.recorder;
        console.log("recorder==================", recorder);
        recorder.start();
      }

      this.startState = true;
      this.endState = false;

      if (that.recordType == 0) {
        that.seconds = that.setInfo.preparatTime;
        that.promptingLanguage = 'Prepare your response';
      } else {
        that.seconds = that.setInfo.recordTime;
        that.promptingLanguage = 'Recording...';
      }

      console.log(that.setInfo); //开始记录录制时长 

      if (!this.recordInterval) {
        this.recordInterval = setInterval(function () {
          that.recordTimeAdd();
        }, 1000);
      }
    },
    endRecord: function endRecord() {
      var that = this;
      var recorder = this.recorder;
      var isRecording = this.isRecording;
      this.endState = true;
      this.startState = false;
      clearInterval(this.recordInterval);
      this.recordInterval = null; //上传成功后 判断如果当前是 准备录制完成 则进行正式录制的开始

      if (that.recordType == 0) {
        that.clickZsRecord();
      } else {
        // 判断是否可以重复录制  禁用掉录制按钮
        if (!that.ifCanRepeat) {
          that.ifCanStart = false;
        }

        var blob = recorder.upload();
        console.log("blob==========", blob);
        var audio = {};
        audio.src = URL.createObjectURL(blob);
        audio.controls = true;
        this.uploadFile(audio, blob);
      }
    },
    //录制时长增加
    recordTimeAdd: function recordTimeAdd() {
      this.recordTime++;
      console.log("recordTime===========", this.recordTime);
    },
    uploadFile: function uploadFile(audio, blob) {
      var _this = this;

      var that = this;
      var formData = new FormData();
      var nowDate = new Date();
      var fileName = "录制音频_" + nowDate.getTime() + ".mp3";
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);

      if (isMac) {
        console.log("这是mac系统");
        fileName = "录制音频_" + nowDate.getTime();
      } // var fileName = "录制音频_" + nowDate.getTime() + ".mp3";


      audio.name = fileName;
      formData.append("file", blob, fileName);
      var url = '/servlet/OmFileUploadServlet';
      var saveLoading = that.$loading({
        lock: true,
        text: '上传录制音频中,请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$axios.post(url, formData).then(function (res) {
        console.log("==success===", res);
        saveLoading.close();
        var arr = res.data.split(":");
        var downAddress = arr[0];
        var fileId = arr[1];
        audio.fileId = fileId;
        audio.downAddress = downAddress;
        audio.fileType = "audio";

        _this.audioSrc.push(audio);

        _this.$emit("callBack", _this.audioSrc);
      }).catch(function (error) {
        if (saveLoading) {
          saveLoading.close();
        }

        console.log("==error===" + error);
      });
    }
  }
};